export const MATERIAL_LIST_ALL_REQUEST = "MATERIAL_LIST_ALL_REQUEST";
export const MATERIAL_LIST_ALL_SUCCESS = "MATERIAL_LIST_ALL_SUCCESS";
export const MATERIAL_LIST_ALL_FAIL = "MATERIAL_LIST_ALL_FAIL";

export const MATERIAL_DETAILS_REQUEST = "MATERIAL_DETAILS_REQUEST";
export const MATERIAL_DETAILS_SUCCESS = "MATERIAL_DETAILS_SUCCESS";
export const MATERIAL_DETAILS_FAIL = "MATERIAL_DETAILS_FAIL";
